export const APIS = {
  Login: {
    // Trial: "/users/users-trial/login/",
  },
  SignUp: {
    // Individual: "/users/individual/create/",
  },
  ChangePassword: "/admin/auth/change-password",
  Common: {
    AppSetup: "/common/master/app-setup",
    //
    Rules: "/common/master/rules",
    TAndC: "/common/master/t-and-c",
    Privacy: "/common/master/privacy",
    Users: "/common/master/users",
    //
    AllGames: "/common/games/all-games",
    AllCompetitionsMatchs: "/common/games/all-competitions-matchs?",
    MatchDetails: "/common/games/match-details",
    MatchOdds: "/common/games/match-odds",
    AllLiveMarketsData: "/common/games/all-live-markets-data",
    OnlyLiveGamesMatches: "/common/games/only-live-games-matches?",
    MarketAnalysisLiveGamesMatches:
      "/common/games/market-analysis-games-matches?",
  },
  Admin: {
    AdminLoginAndDetails: "/admin/auth/admin-login",
  },
  Roles: {
    Roles: "/admin/roles",
    AllPermissions: "/admin/roles/all-permissions",
  },
  Management: {
    SSM: {
      CRUD: "/admin/management/ssm",
      UserLock: "/admin/management/ssm/is-user-locked/",
      BetLock: "/admin/management/ssm/is-bet-locked/",
    },
    SM: {
      CRUD: "/admin/management/sm",
      UserLock: "/admin/management/sm/is-user-locked/",
      BetLock: "/admin/management/sm/is-bet-locked/",
    },
    Master: {
      CRUD: "/admin/management/master",
      UserLock: "/admin/management/master/is-user-locked/",
      BetLock: "/admin/management/master/is-bet-locked/",
    },
    Client: {
      CRUD: "/admin/management/client",
      UserLock: "/admin/management/client/is-user-locked/",
      BetLock: "/admin/management/client/is-bet-locked/",
    },
    Statement: {
      Statement: "/admin/management/statement",
      Deposit: "/admin/management/statement/deposit",
      Withdrawal: "/admin/management/statement/withdrawal",
      Credit: "/admin/management/statement/credit",
      Debit: "/admin/management/statement/debit",
      UserList: "/admin/management/statement/users-list",
      ExposureList: "/admin/management/statement/exposure-list",
      PAndLListModel: "/admin/management/statement/p-and-l-list",
      PAndLList: "/admin/management/statement/p-and-l-list",
    },
  },
  Profile: {
    Users: "/admin/profile/users",
    Statement: {
      CRUD: "/admin/profile/statement",
      Exports: "/admin/profile/statement-exports",
    },
    Completedbets: {
      CRUD: "/admin/profile/completed-bets",
      Exports: "/admin/profile/completed-bets-exports",
    },
    AllCommission: {
      CRUD: "/admin/profile/all-commission",
      Exports: "/admin/profile/all-commission-exports",
    },
    Activity: {
      CRUD: "/admin/profile/activity",
    },
    Bets: {
      LiveBets: "/admin/profile/live-bets",
      UnmatchBets: "/admin/profile/unmatch-bets",
      LiveBetsAmount: "/admin/profile/live-bets-amount",
      BookShow: "/admin/profile/bookshow",
      BookShowBets: "/admin/profile/bookshow-bets",
      Jackpot: "/admin/profile/jackpot",
      MarketsStatus: "/admin/profile/markets-status",
      RunnerStatus: "/admin/profile/runner-status",
      RemoveBets: "/admin/profile/remove-bet",
    },

    Settlement: {
      AllUserSettlement: "/admin/profile/all-users-settlement",
      Settlement: "/admin/profile/settlement",
      SettlementExports: "/admin/profile/settlement-exports",
      ManageSettlement: "/admin/profile/manage-settlement",
      OneSettlement: "/admin/profile/one-settlement",
      AllSettlement: "/admin/profile/all-settlement",
      ManageSettlementList: "/admin/profile/manage-settlement-list",
    },
  },
  Policy: {
    Rules: {
      CRUD: "/admin/policy/rules",
    },
    TAndC: {
      CRUD: "/admin/policy/t-and-c",
    },
    Privacy: {
      CRUD: "/admin/policy/privacy",
    },
  },
  Masters: {
    AppSetup: {
      CRUD: "/admin/masters/app-setup",
    },
    BetButton: {
      CRUD: "/admin/masters/bet-buttons",
    },
    SocialMedia: {
      CRUD: "/admin/masters/social-media",
    },
    JournalEntries: {
      CRUD: "/admin/masters/journal-entries",
      History: "/admin/masters/journal-entries/history",
    },
    ContactUs: {
      CRUD: "/admin/masters/contact-us",
    },
    BetSettlement: {
      CRUD: "/admin/masters/bet-settlement",
    },

    Types: {
      CRUD: "/admin/masters/type",
      OddsStatus: "/admin/masters/type-odds",
      Status: "/admin/masters/type-status",
    },
    State: {
      CRUD: "/admin/masters/state",
    },
    Banner: {
      CRUD: "/admin/masters/banner",
    },
    Bigwin: {
      CRUD: "/admin/masters/bigwin",
    },
    Agent: {
      CRUD: "/admin/masters/agent",
    },
    Leaderboard: {
      CRUD: "/admin/masters/leaderboard",
    },
  },
  Wallets: {
    Fund: {
      Request: "/admin/wallet/fund-request",
      Action: "/admin/wallet/fund-action",
    },
    Withdraw: {
      Request: "/admin/wallet/withdraw-request",
      Action: "/admin/wallet/withdraw-action",
    },
  },
};
